/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Property } from "../../property/types/Property";
import { EnumDetails } from "./EnumDetails";
import { Metadata } from "./Metadata";
export const Edge = core.serialization.object({
    sourceField: Property,
    destinationField: Property,
    preview: core.serialization.list(core.serialization.string()).optional(),
    enumDetails: EnumDetails.optional(),
    metadata: Metadata.optional(),
});
